<fieldset bsMigration [bs3Class]="['panel-default']" [bs4Class]="['mb-3']" class="panel" [disabled]="isSaving" #fieldset>
  <legend bsMigration class="panel-heading">Phone Number</legend>
  <div bsMigration class="panel-body">
    <app-phone-field
      [bs4Class]="['mb-3']"
      class="form-group"
      *ngFor="let phone of Groups; let index=index; let first=first; let last=last"
      [Title]="index === 0 ? 'Primary Phone Number' : 'Additional Phone Number'"
      [group]="phone"
      [index]="index"
      [last]="last"></app-phone-field>
    <div>
      <button *ngIf="array.length < 3" title="Add" class="btn btn-sm btn-info" [disabled]="array.invalid" (click)="addPhone(true)" type="button"><fa-icon [icon]="faPlus"></fa-icon> Add Phone Number</button>
    </div>
  </div>
</fieldset>
